import { ICartao } from './../interfaces/cartao.interface';
import { ICedente } from './../interfaces/cedente.interface';
import { IEndereco } from './../interfaces/endereco.interface';
import { IAdquirente } from './../interfaces/adquirente.interface';
import { IInformacaoBancaria } from '../interfaces/informacao-bancaria.interface';

export class Conta {
  public Nome = '';
  public Sobrenome = '';
  public TipoConta = '';
  public Senha = '';
  public TipoCadastro = '';
  public Email = '';
  public Telefone = '';
  public CpfCnpj = '';
  public RetornoUrl = '';
  public RazaoSocial = '';
  public Fantasia = '';
  public InscricaoMunicipal = '';
  public VendedorId = '';
  public Situacao = '0';
  public Cedentes: ICedente[];
  public Adquirentes: IAdquirente[];
  public InformacoesBancarias: IInformacaoBancaria[];
  public Enderecos: IEndereco[];
  public Cartoes: ICartao[];
  public Objetos: any[];
  public Pendencias: any[];
  public Validacao: any;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/conta.ts